export default [
    {
        path: "sfp/list",
        name: "sfpList",
        component: () => import(/* webpackChunkName: "stp" */ "@/views/sfp/sfp/index"),
    },
    {
        path: "sfp/list/update/:type",
        name: "sfpUpdate",
        component: () => import(/* webpackChunkName: "stp" */ "@/views/sfp/sfp/update"),
    },
    {
        path: "sfp/calculation",
        name: "sfpCalculation",
        component: () => import(/* webpackChunkName: "sfpCalculation" */ "@/views/sfp/calculation/index"),
    },
    {
        path: "sfp/other",
        name: "sfpOther",
        component: () => import(/* webpackChunkName: "sfpCalculation" */ "@/views/sfp/other/index"),
    },

    {
        path: "dynamicerpsku",
        name: "dynamiclist",
        component: () => import(/* webpackChunkName: "sfpCalculation" */ "@/views/sfp/dynamicerpsku/index"),
    },

    // wayfail
    {
        path: "sfp/wayfail/list",
        name: "sfpWayfailList",
        component: () => import(/* webpackChunkName: "stp" */ "@/views/sfp/wayfail/index"),
    },
    {
        path: "sfp/wayfail/list/update/:type",
        name: "sfpWayfailUpdate",
        component: () => import(/* webpackChunkName: "stp" */ "@/views/sfp/wayfail/update"),
    },
]